module.exports = __webpack_public_path__ + "static/media/flap_pocketsx2.15979f52.svg";